/**
 * 定义`menu`组件用到的常量
 */
import { PREFIX_CLASS } from '../../utils/constants'

export const PREFIX_MENU_CLASS = `${PREFIX_CLASS}menu`



// WEBPACK FOOTER //
// ./src/components/menu/constants.js